// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item-details-wrapper":"styles__view-slider-item-details-wrapper__3JPd6","viewSliderItemDetailsWrapper":"styles__view-slider-item-details-wrapper__3JPd6"};